/** @file The chosen analysis's argument form, generated from its AUTORIG_ACTIONS fields. */
import type { AutorigFn } from '@pose2d/api/autorig/autorigFns';
import type { Doc } from '@pose2d/format/types';
import type { Translate } from '@pose2d/i18n/types';
import { actionOf } from './actionOf';
import { ArgFieldView } from './ArgFieldView';

/** Props of ArgsForm; `args` is the form state (cleaned by readyArgs before a run). */
export interface ArgsFormProps {
  t: Translate;
  fn: AutorigFn;
  args: Readonly<Record<string, unknown>>;
  doc: Doc;
  onChange: (args: Record<string, unknown>) => void;
}

/** Nothing for an analysis without arguments; `undefined` removes a key. */
export function ArgsForm({ t, fn, args, doc, onChange }: ArgsFormProps) {
  const fields = actionOf(fn).fields;
  if (fields.length === 0) return null;
  const set = (key: string, value: unknown): void => {
    const rest = Object.entries(args).filter(([k]) => k !== key);
    onChange(Object.fromEntries(value === undefined ? rest : [...rest, [key, value]]));
  };
  return (
    <div className="autorig-args">
      {fields.map((field) => <ArgFieldView key={field.key} t={t} field={field} value={args[field.key]} doc={doc} onChange={(value) => { set(field.key, value); }} />)}
    </div>
  );
}
